import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
export const linkToUsersAndTeamSettings = (paid = false) => `${getFullUrl('app')}/settings/${PortalIdParser.get()}/users/${paid ? 'paid-users' : ''}`;